import { loadRemoteExport } from 'features/mfe/components/EsModule/remoteLoader';
import type { ValidateFlavorContentFn } from 'features/traffic/campaigns/campaign-configs/types';
import type { ValidatorType } from 'types/JourneysDeclarativeUI';
import type { ObjectLikeValidationResult } from 'utils/validation/validate-schema/validate-schema.types';
import type { TContent, TFormValues } from '../types';

/*
 * Temporarily disable validation in our Cypress tests.
 * See this doc for full explanation: https://quip-amazon.com/1GwPANa8eTUW/RJSF-Validation-and-Remount-Issue
 * SIM ticket tracking: https://t.corp.amazon.com/P319708907
 */
const SKIP_VALIDATION = window.Cypress && window.__DISABLE_FORM_VALIDATION__;

/**
 * Async validation function that uses remote MFE validator and form instance validation
 * This function loads and uses the remote validator from the MFE (with automatic caching)
 */
export const validateFlavorContent: ValidateFlavorContentFn<TContent, TFormValues> = async ({ content, contentConfiguration }) => {
  if (SKIP_VALIDATION) return;

  const { jsonSchema, customValidate } = contentConfiguration ?? {};

  const validationErrors: ObjectLikeValidationResult = {};

  if (!jsonSchema || !content) {
    validationErrors.general = 'JSON schema and flavor content are required for validation';
    return validationErrors;
  }

  const validator = await loadRemoteExport<ValidatorType>('JourneysDeclarativeUI', 'validator');
  const validationResult = validator.validateFormData(content, jsonSchema, customValidate);
  if (validationResult.errors.length === 0) return;

  validationResult.errors.forEach((error) => {
    const fieldPath = error.property || 'general';
    validationErrors[fieldPath] = error.message || 'Validation error';
  });

  return validationErrors;
};
